const toTimestamp = (value) => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

export const NEW_PRODUCTS_SIDEBAR_LIMIT = 5;

export const sortProductsByNewest = (products = []) => (
  [...products].sort((a, b) => {
    const createdDiff = toTimestamp(b.createdAt) - toTimestamp(a.createdAt);
    if (createdDiff !== 0) return createdDiff;
    return (b.id || 0) - (a.id || 0);
  })
);

export const getNewestProducts = (products = [], limit = NEW_PRODUCTS_SIDEBAR_LIMIT) => (
  sortProductsByNewest(products).slice(0, limit)
);
